import { render, staticRenderFns } from "./FileVerification.vue?vue&type=template&id=1839b0a1&scoped=true&"
import script from "./FileVerification.vue?vue&type=script&lang=js&"
export * from "./FileVerification.vue?vue&type=script&lang=js&"
import style0 from "./FileVerification.vue?vue&type=style&index=0&id=1839b0a1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1839b0a1",
  null
  
)

export default component.exports